import { useState } from 'react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import ImageStorage from '../../utils/ImageStorage';

const PromotionsSection = () => {
  const [swiper, setSwiper] = useState<SwiperCore>();

  const handleClickPrev = () => {
    swiper?.slidePrev();
  };

  const handleClickNext = () => {
    swiper?.slideNext();
  };

  return (
    <div className='promotions relative'>
      <div className='container mx-auto flex flex-col items-center'>
        <div className='promo-title'></div>
        <a
          className='promo-button-play'
          href='/play-game'
          target='_blank'
          rel='noreferrer'
        >
          CLICK CHƠI NGAY
        </a>
        <div className='promo-wrapper px-2 lg:px-16 w-full relative'>
          <div className='promo-sliders swiper'>
            <div className='swiper-wrapper'>
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={1}
                loop
                autoplay={{ delay: 5000 }}
                onInit={(swiper: SwiperCore) => {
                  setSwiper(swiper);
                }}
              >
                <SwiperSlide>
                  <div className='promo-slide swiper-slide'>
                    <img
                      src={ImageStorage.HomePromotion1}
                      alt='home-promotion-1'
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='promo-slide swiper-slide'>
                    <img
                      src={ImageStorage.HomePromotion2}
                      alt='home-promotion-2'
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='promo-slide swiper-slide'>
                    <img
                      src={ImageStorage.HomePromotion3}
                      alt='home-promotion-3'
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div
            className='promo-nav-button promo-button-prev swiper-button-prev'
            onClick={handleClickPrev}
          ></div>
          <div className='promo-nav-button promo-button-next swiper-button-next'  onClick={handleClickNext}></div>
        </div>
      </div>
    </div>
  );
};

export default PromotionsSection;
